import { Text } from './text/component.js';
import { Title } from './title/index.js';
import { TitleMobile } from './title-mobile/component.js';
import { TitleResponsive } from './title-responsive/component.js';

var Typography = {
    Title: Title,
    Text: Text,
    TitleResponsive: TitleResponsive,
    TitleMobile: TitleMobile,
};

export { Typography };
